<template>
  <div
    v-if="item.parent === '0'"
    class="menu-items group relative items-center"
    :class="`${hasSub(item)} ${
      device === 'mobile' || device === 'tablet' ? 'mobile-subnav-root' : ''
    }`">
    <template v-if="hasSubnav(item)">
      <template v-if="device === 'mobile' || device === 'tablet'">
        <div class="z-2 relative w-full">
          <button
            type="button"
            class="header-1 mobile-subnav-parent mobile-subnav-label lg:mb-0"
            :class="subnavOpen ? 'mb-3' : ''"
            :aria-expanded="subnavOpen ? 'true' : 'false'"
            :aria-controls="mobileSubnavId"
            @click.stop.prevent="openSubnav">
            <span
              class="mobile-subnav-text"
              v-html="item.content"></span>
            <span
              class="submenu-trigger z-1 top-0 h-full w-full lg:top-0 -right-0 lg:-right-10 absolute lg:h-[8px] lg:w-[15px]"
              aria-hidden="true">
              <img
                class="caret mobile-parent-caret ml-2 absolute right-[25px]"
                :class="{ 'is-open': subnavOpen }"
                src="@/assets/img/caret-down.svg" />
            </span>
          </button>
        </div>
      </template>
      <template v-else>
        <button
          type="button"
          class="header-1 desktop-subnav-parent desktop-subnav-trigger mb-3 lg:mb-0"
          :class="{
            'desktop-mega-active': props.desktopMegaActive,
            'desktop-tertiary-active': hasActiveTertiary,
          }"
          :aria-expanded="props.desktopMegaActive ? 'true' : 'false'"
          aria-controls="desktop-mega-menu"
          @click.stop.prevent="openDesktopParent">
          <span
            class="desktop-subnav-label"
            v-html="item.content"></span>
          <img
            class="desktop-subnav-caret ml-2 group-hover:rotate-180"
            :class="{ 'rotate-180': props.desktopMegaActive }"
            src="@/assets/img/caret-down-mega.svg"
            alt="" />
        </button>
      </template>
      <template v-if="device === 'mobile' || device === 'tablet'">
        <slide-up-down
          :id="mobileSubnavId"
          v-model="subnavOpen"
          class="subnav-accordion">
          <ul class="sub-menu">
            <template
              v-for="subItem in mobileSubmenuItems(item)"
              :key="subItem.id">
              <li class="mobile-tertiary-item">
                <template v-if="isExternal(subItem.url)">
                  <a
                    class="header-1 mobile-tertiary-link"
                    :class="arrayToString(subItem.class)"
                    :href="subItem.url"
                    :target="subItem.target"
                    :title="subItem.content"
                    @click="closeNav">
                    <span v-html="subItem.content"></span>
                    <span
                      v-if="subItem.description"
                      class="mobile-tertiary-description"
                      v-html="subItem.description"></span>
                  </a>
                </template>
                <template v-else>
                  <router-link
                    class="header-1 mobile-tertiary-link"
                    :class="arrayToString(subItem.class)"
                    :to="convertToRelative(subItem.url)"
                    @click="closeNav">
                    <span v-html="subItem.content"></span>
                    <span
                      v-if="subItem.description"
                      class="mobile-tertiary-description"
                      v-html="subItem.description"></span>
                  </router-link>
                </template>
              </li>
            </template>
          </ul>
        </slide-up-down>
      </template>
    </template>
    <template v-else-if="item.class.includes('CTA') && !device === 'mobile'">
      <router-link
        class="header-1"
        :to="convertToRelative(item.url)"
        exact
        @click="closeNav">
        <span v-html="item.content"></span>
        <svg
          class="ml-2"
          width="17"
          height="8"
          viewBox="0 0 17 8"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.844 4.18558C17.0393 3.99032 17.0393 3.67374 16.844 3.47848L13.6621 0.296497C13.4668 0.101235 13.1502 0.101235 12.955 0.296497C12.7597 0.491759 12.7597 0.808342 12.955 1.0036L15.7834 3.83203L12.955 6.66046C12.7597 6.85572 12.7597 7.1723 12.955 7.36757C13.1502 7.56283 13.4668 7.56283 13.6621 7.36757L16.844 4.18558ZM0.925781 4.33203H16.4905V3.33203H0.925781V4.33203Z" />
        </svg>
      </router-link>
    </template>
    <template v-else>
      <router-link
        v-if="!isExternal(item.url)"
        class="header-1"
        :target="item.target"
        :to="convertToRelative(item.url)"
        exact
        @click="closeNav">
        <span v-html="item.content" />
        <!-- <div
          v-if="device === 'mobile'"
          class="hex-container">
          <img
            src="@/assets/img/hex.svg"
            alt="" />
        </div> -->
        <div class="hex-container">
          <img
            src="@/assets/img/hex.svg"
            alt="" />
        </div>
      </router-link>
      <a
        v-else
        class="header-1"
        :target="item.target"
        :href="item.url"
        exact
        @click="closeNav">
        <span v-html="item.content" />
        <!-- <div
          v-if="device === 'mobile'"
          class="hex-container">
          <img
            src="@/assets/img/hex.svg"
            alt="" />
        </div> -->
        <div class="hex-container">
          <img
            src="@/assets/img/hex.svg"
            alt="" />
        </div>
      </a>
    </template>
  </div>
</template>

<script setup>
import SlideUpDown from 'vue3-slide-up-down'
import useUtils from '@/components/composables/useUtils.js'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

const { device, convertToRelative, isExternal } = useUtils()
const props = defineProps(['menu', 'item', 'desktopMegaActive'])
const emit = defineEmits(['open-desktop-mega', 'clicked'])
const route = useRoute()
const subnavOpen = ref()
const mobileSubnavId = computed(() => `mobile-subnav-${props.item.id}`)

const hasSub = (item) => {
  return hasSubnav(item)
    ? `parent-nav has-subnav ${arrayToString(item.class)}`
    : `${arrayToString(item.class)}`
}

const hasSubnav = (item) => {
  return item.class.includes('has-subnav') || childrenOf(item).length > 0
}
const openSubnav = () => {
  subnavOpen.value = !subnavOpen.value
}

const openDesktopParent = () => {
  emit('open-desktop-mega')
}

const closeNav = () => {
  subnavOpen.value = false
  emit('clicked', false)
}

const childrenOf = (parentItem) => {
  if (!parentItem || !Array.isArray(props.menu)) {
    return []
  }

  return props.menu.filter((menuItem) => menuItem.parent == parentItem.id)
}

const normalizePath = (value) => {
  if (!value) return ''

  try {
    const path = new URL(value, window.location.origin).pathname
    return path.replace(/\/+$/, '') || '/'
  } catch {
    return String(value).split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  }
}

const hasActiveTertiary = computed(() => {
  const tertiaryItems = childrenOf(props.item).flatMap((secondary) =>
    childrenOf(secondary)
  )
  const currentPath = normalizePath(route.path)

  return tertiaryItems.some(
    (tertiary) =>
      !isExternal(tertiary.url) && normalizePath(tertiary.url) === currentPath
  )
})

const mobileSubmenuItems = (parentItem) => {
  const secondaryItems = childrenOf(parentItem)
  const tertiaryItems = secondaryItems.flatMap((secondary) =>
    childrenOf(secondary)
  )

  return tertiaryItems.length ? tertiaryItems : secondaryItems
}

const arrayToString = (array) => {
  return array.join(' ')
}
</script>

<style lang="scss">
.caret {
  @apply w-[15px] h-[8px] absolute top-[calc(50%-4px)] right-0 self-center transition duration-500 filter lg:brightness-100;
  @apply lg:relative lg:self-center lg:top-auto;
}

li {
  @apply relative;
  .menu-items {
    @apply w-full 
    flex flex-col py-[15px] relative fill-white stroke-white
    border-b-[1px] border-b-progressive
    md:pb-5
    lg:w-auto lg:py-0 lg:border-0;
    &.orange {
      a {
        @apply text-gray-600;
      }
    }
    &.has-subnav {
      @apply flex;
      a {
      }
    }
    .sub-menu {
      li {
        @apply p-0;
        a {
          @apply pb-4 lg:pb-0 lg:p-10 lg:pr-16 w-full inline-block;
        }
      }

      .mobile-secondary-item {
        @apply flex flex-col items-start text-left;
      }

      .mobile-secondary-title {
        @apply m-0 w-full pb-3 text-white opacity-70;
      }

      .mobile-tertiary-menu {
        @apply m-0 flex w-full list-none flex-col items-start gap-4 bg-transparent p-0 pb-5;
      }

      .mobile-tertiary-item {
        @apply w-full justify-start text-left;
      }

      .mobile-tertiary-link {
        @apply flex flex-col leading-tight gap-1 p-0 text-left w-full text-white;
      }

      .mobile-overview-link {
        @apply relative flex w-full p-0 text-left text-[20px] leading-[1] text-white no-underline;
      }

      .mobile-tertiary-description {
        @apply text-[14px] leading-[1.3] opacity-70;
      }
    }
    a {
      @apply relative  text-[34px]   self-center lg:self-start
    lg:text-humble lg:text-[16px] lg:hover:opacity-100 lg:hover:text-gray-600
    w-full h-full duration-200 transition ease-in-out;
      span {
        @apply text-white
        lg:text-humble;
      }
      .hex-container {
        @apply flex items-center justify-center opacity-0  top-0 right-0 absolute h-full w-5
        
          lg:right-[50%] lg:translate-x-[50%] lg:top-5  lg:transition-all lg:duration-[400ms] lg:ease-in-out;
        img {
          @apply lg:scale-50 lg:rotate-[180deg] lg:transition-all lg:duration-[400ms] lg:ease-in-out;
        }
      }
      &:hover {
        .hex-container {
          @apply lg:opacity-100;
          img {
            @apply lg:scale-100 lg:rotate-[0deg];
          }
        }
      }
    }
    a.router-link-active {
      span {
        @apply opacity-100;
      }
      .hex-container {
        @apply opacity-100;
      }
    }
    .subnav-accordion {
      @apply w-full;
    }
  }
}

.desktop-subnav-parent {
  @apply flex flex-row justify-center transition-opacity duration-200;
  stroke: inherit;
}

.header-1.desktop-subnav-trigger {
  @apply h-[43px] cursor-pointer items-center whitespace-nowrap border-0 bg-transparent p-0 text-left text-humble;
  font-size: 16px !important;
  line-height: 20px !important;
}

.desktop-subnav-caret {
  @apply h-[8px] w-[15px] shrink-0 transition-transform duration-300 ease-in-out;
}

@media (min-width: 1024px) {
  .menu-items > .header-1 > span,
  .menu-items > .desktop-subnav-parent > .desktop-subnav-label {
    @apply relative;

    &::after {
      @apply pointer-events-none absolute left-0 right-0 opacity-0;
      content: '';
      bottom: -7px;
      height: 2px;
      background: linear-gradient(90deg, #79f4dc 0 50%, #13d377 50% 100%);
      transform: scaleX(0);
      transform-origin: left center;
      transition: transform 0.25s ease-out, opacity 0.2s ease-out;
    }
  }

  .menu-items > .header-1:hover > span::after,
  .menu-items > .header-1.router-link-active > span::after,
  .menu-items > .desktop-subnav-parent:hover > .desktop-subnav-label::after,
  .menu-items
    > .desktop-subnav-parent.desktop-tertiary-active
    > .desktop-subnav-label::after,
  .menu-items
    > .desktop-subnav-parent.desktop-mega-active
    > .desktop-subnav-label::after {
    @apply opacity-100;
    transform: scaleX(1);
  }

  .menu-items > .header-1 .hex-container {
    display: none;
  }
}

.mobile-subnav-parent {
  @apply inline-block text-[34px] leading-[1] text-white opacity-100 transition-opacity duration-200 lg:text-[16px] lg:leading-normal;
  stroke: inherit;
}

.mobile-subnav-label {
  @apply border-0 bg-transparent p-0 text-left text-white;
}

@media (max-width: 1023px) {
  .header-1.mobile-subnav-label {
    @apply relative block w-full self-center;
    font-size: 34px !important;
    line-height: 43px !important;
  }

  .mobile-parent-caret {
    top: 50% !important;
    transform: translateY(-50%) rotate(0deg);
    transition: transform 0.3s ease-in-out;

    &.is-open {
      transform: translateY(-50%) rotate(180deg);
    }
  }
}

.mobile-subnav-text {
  @apply text-white;
}

.mobile-subnav-root {
  img {
    &::before {
      @apply content-[''] absolute w-full h-full bg-green-500;
    }
  }
}

li.CTA {
  @apply lg:p-0;
  a {
    @apply lg:border lg:border-white lg:p-3 lg:px-6 lg:flex lg:items-center lg:content-center;
    svg {
      fill: inherit;
      stroke: none;
    }
  }
}

.sub-menu {
  @apply pl-3 relative lg:absolute flex flex-col gap-3 top-0
      lg:right-[-15px] lg:transform lg:translate-y-[-999999px]
      md:shadow-xl xl:max-w-[800px] w-full xl:w-max;

  @apply pt-3;
  li {
    @apply flex justify-center xl:justify-start text-center lg:text-left text-black hover:text-white hover:bg-humble/80
      lg:border-black lg:border-b lg:border-opacity-10 lg:px-2 lg:py-1;
    a {
      @apply flex py-4 text-[20px] lg:last:py-3;
    }
  }

  .mobile-overview-item {
    @apply justify-start text-left;
  }

  .mobile-overview-link {
    @apply flex w-full p-0 pb-3 text-left text-[20px] leading-[1] text-white no-underline;
  }
}
@media all and (min-width: 1024px) {
  ul.sub-menu .triangle {
    content: '';
    position: absolute;
    top: -10px;
    right: 12px;
    height: 10px;
    width: 10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #e9edee;
    clear: both;
    transform: rotate(180deg);
  }
  .sub-menu > li:nth-child(1):hover ~ .triangle {
    border-top: 10px solid rgba(0, 181, 223, 1);
  }
}

.parent-nav:hover .sub-menu {
  @apply lg:opacity-100 transition-opacity duration-500 ease-in-out lg:transform lg:translate-y-[56px];
}

// final styles for menu items
</style>
